import { log } from "./logger";
// ----------------------------------------------------------------------------
export function checkInventoryStackcountByItemId(inventory, idItem, quantity){
    let emptySlot = false;
    const slots = Object.values(inventory);
    log.ui.log(slots);

    for (let i = 0; i < slots.length; i++) {
        const slot = slots[i];
        if (slot) {
            log.ui.log("il y a un slot", slot);
            log.ui.log(slot.item.id, idItem);
            if (slot.item.id === idItem) {
                log.ui.log("l'objet est identique à l'item id");
                // L'objet est dans l'inventaire: verifier si il est empilable
                if (slot.item.stackable) {
                    // L'objet est empilable: vérifier les quantités
                    log.ui.log("l'objet est stackable");
                    if ( (quantity + slot.quantity) < slot.item.stackCount ) {
                        // La quantité à ajouter plus la quantité dans l'inventaire ne depassent pas le maximum de la pile : on peut ajouter
                        log.ui.log("on peut ajouter", (quantity + slot.quantity) < slot.item.stackCount);
                        return true;
                    } else {
                        // La quantité à ajouter plus la quantité dans l'inventaire depassent le maximum de la pile : on ne peut pas ajouter
                        log.ui.log("on ne peut pas ajouter", (quantity + slot.quantity) < slot.item.stackCount);
                        return false;
                    } 
                } else {
                    // L'objet n'est pas empilable :  on ne peut pas ajouter
                    log.ui.log("L'objet n'est pas empilable :  on ne peut pas ajouter");
                    return false;
                }
            }
        } else if(!emptySlot){
            // Ce slot est vide : vérifier si l'objet est dans un prochain slot.
            // Se souvenir qu'il y a un slot de libre
            emptySlot = true;
        }
    }

    return emptySlot;
}